import { HelpOutline } from "@mui/icons-material"
import { Tooltip, Typography, Box } from "@mui/material"

export const LoadFeeTooltip = () => {
    return (
        <Tooltip 
            title={
                <Box sx={{ p: 0.5 }}>
                    <Typography variant="subtitle2" sx={{ fontWeight: 'bold', mb: 0.5 }}>
                        Load Fee
                    </Typography>
                    <Typography variant="body2">
                        A percentage charge on the amount made available to a cardholder. This fee covers the cost of making the funds available for use and ensures smooth processing.
                    </Typography>
                </Box>
            } 
            sx={{ marginRight: "auto", marginLeft: "4px" }}
        >
            <HelpOutline />
        </Tooltip>
    )
}